import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Arrow } from '../../shared/icons/arrow';

import styles from './navItem.module.css';

/**
 * @param {Object} props
 * @param {string} [props.to='#'] The path to go to on click
 * @param {string} [props.label=''] The label to the right of the icon
 * @param {JSX.Element} [props.icon] The Svg Icon to display
 * @param {JSX.Element|JSX.Element[]} [props.children] Nested Links
 * @param {(state: boolean) => void} [props.onExpandChange] Nested Links
 */
export const NavItem = ({
        to = '#',
        label = '',
        icon,
        children = [],
        onExpandChange = () => {},
        ...props
    }) => {

    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        if (childCount() > 0)
            onExpandChange(expanded);
    }, [expanded]);

    const childrenArray = () => Array.isArray(children) ? children : [children]; 

    const childCount = () => childrenArray()?.length ?? 0;

    const totalDelay = 0.1;
    const delayIncrement = childCount() === 0 ? 0 : totalDelay / (childCount() - 1);

    return <div className={styles.Wrapper} {...props}>
        <Link to={to} className={styles.NavItem} onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}>
            <div className={styles.Icon + ' icon'}>
                {icon}
            </div>
            <div className={styles.Label}>
                {label}
            </div>
            <div className={styles.Arrow}>
                {
                    (childCount() > 0) ?
                    <Arrow direction={expanded ? 'up' : 'down'} />
                    : ''
                }
            </div>
        </Link>
        <div className={styles.Children + (expanded ? ' ' + styles.Expanded : '')}
            style={{
                height: childCount() * 37 + 'px'
            }}>
            {
                React.Children.map(childrenArray(), (c, i) =>
                    <c.type {...c.props} style={{
                        transitionDelay: (expanded ? 
                            delayIncrement * i 
                            :
                            totalDelay - delayIncrement * (i)
                        ) + 's'
                    }}/>
                )
            }
        </div>
    </div>
}